import axios from 'axios'

import { unique } from '@/helpers/api'
import type { OneOf, PageNumberPagination, UUID } from '@/types'
import type { CorpusExport, ExportFormat, ExportSource } from '@/types/export'
import type { Process } from '@/types/process'

import type { PageNumberPaginationParameters } from '.'

export interface ListExportParams extends PageNumberPaginationParameters {
  dataset_id?: UUID
}

// List a corpus' exports
export const listExports = unique(
  async (
    corpusId: UUID,
    params: ListExportParams = {},
  ): Promise<PageNumberPagination<CorpusExport>> =>
    (await axios.get(`/corpus/${corpusId}/export/`, { params })).data,
)

export interface StartExportParams {
  source?: string
  dataset_id?: UUID
}

// Start an export on a corpus
export const startExport = unique(
  async (corpusId: UUID, params: StartExportParams): Promise<CorpusExport> =>
    (await axios.post(`/corpus/${corpusId}/export/`, params)).data,
)

// Delete a corpus export
export const deleteExport = unique(async (id: UUID) => await axios.delete(`/export/${id}/`))

/**
 * List the available sources to run exports on.
 * Available on Arkindex EE only.
 */
export const listExportSources = unique(
  async (): Promise<ExportSource[]> => (await axios.get('/export-sources/')).data,
)

export type CreateExportProcessParams = {
  format: ExportFormat
  configuration?: Record<string, unknown>
  farm_id?: UUID | null
} & OneOf<[{ element_id?: UUID }, { selection?: boolean }]>

// Start an export process
export const createExportProcess = async (
  corpusId: UUID,
  params: CreateExportProcessParams,
): Promise<Process> => (await axios.post(`/process/export/${corpusId}/`, params)).data
